import { render, staticRenderFns } from "./SchedaMorteDatiDecessoComponent.vue?vue&type=template&id=78200e94"
import script from "./SchedaMorteDatiDecessoComponent.vue?vue&type=script&lang=js"
export * from "./SchedaMorteDatiDecessoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports